import { collection } from 'firebase/firestore';

// src/adapters/firebase/collections/user.ts
var userCollection = (db) => collection(db, "users");

export { userCollection };
//# sourceMappingURL=chunk-FQN2HH6G.mjs.map
//# sourceMappingURL=chunk-FQN2HH6G.mjs.map